import countryList from 'react-select-country-list';


// eslint-disable-next-line import/prefer-default-export
export const allCountriesList = [{ label: '', value: '' }, ...countryList().getData()];
